import { useEffect, useMemo, useState } from "react";
import { fetchAuthorizedFileBlobUrl, resolveFileReference, revokeObjectUrl } from "../services/uploadService";

function useProtectedFileUrl(fileUrl, storageKey) {
  const directUrl = useMemo(() => resolveFileReference(fileUrl, storageKey), [fileUrl, storageKey]);
  const [resolvedUrl, setResolvedUrl] = useState(directUrl);

  useEffect(() => {
    let cancelled = false;
    let activeBlobUrl = "";
    setResolvedUrl(directUrl);

    async function resolveUrl() {
      if (!fileUrl && !storageKey) {
        setResolvedUrl("");
        return;
      }

      try {
        const nextUrl = await fetchAuthorizedFileBlobUrl(fileUrl, storageKey);
        if (cancelled) {
          revokeObjectUrl(nextUrl);
          return;
        }
        activeBlobUrl = nextUrl;
        setResolvedUrl(nextUrl || directUrl);
      } catch {
        if (!cancelled) {
          setResolvedUrl(directUrl);
        }
      }
    }

    resolveUrl();

    return () => {
      cancelled = true;
      revokeObjectUrl(activeBlobUrl);
    };
  }, [fileUrl, storageKey, directUrl]);

  return resolvedUrl;
}

export default useProtectedFileUrl;
